export const isUnauthorized = (e: any) => e?.response?.status === 401;
